import Link from 'next/link';
import Head from 'next/head';

import {WEBSERVER, APISERVER, numberToCurrency, imgpath} from "../../services/globals"
import Popup from 'reactjs-popup';
import { GetStaticProps } from "next";
import { ApolloClient, InMemoryCache, gql, useMutation } from "@apollo/client";
import { ParsedUrlQuery } from "querystring";
import {IActiveOrder, ICart, ProductItem, IArticle, ProductVariant2, Product_list_elem, IFacetValues} from "../../components/contracts/types";
import Soffer from '../../components/soffer'
import {useRouter} from 'next/router';
import MenuComponent from '../../components/menu';
import PlaceCartComponent from '../../components/placecart'
import { Queries } from "../../services/queries";
import React, { useState, useEffect } from "react";
import User from "../../components/user";
import { AppPageRouteModule } from 'next/dist/server/future/route-modules/app-page/module.compiled';

interface IParams extends ParsedUrlQuery {
  slug: string;
}


export default function categorypage({categories,items,slugy}) {
    //console.log("+++++++++++++++++++Items" +JSON.stringify(items.data.collection.productVariant));
    //console.log("+++++++++++++++++++Data",categories);

    
    const [count, setCount] = useState<number | null>(0);
    
    useEffect(() => {
      async function getstartcount ()  {
        let mycount : number = -1;
        const queries = new Queries();
        mycount = await queries.getCartCount();
//        console.log("getstartcount: " + mycount);
        setCount(mycount);
      }
  
      getstartcount();
    }, []);




    function addCart() {
//      console.log("adddCart:" +  count);
      if (count)
        setCount(count + 1);
      else {
        setCount(1);
      }
 //     console.log("addCart:" +  newcount);
        //MenuComponent.setCount(newcount);
    }

     let list = [];
     let sitem : ProductVariant2;
     let facet : IFacetValues;
     let lastid = 0;
     let vcount:number = 0;
     let lastprice : number = Number.MAX_SAFE_INTEGER; //High number

    let path = `<a href="${WEBSERVER}">Home</a>/`;
    let link = WEBSERVER + "/category/" + items.data.collection.parent.slug;

    if (items.data.collection.parent.name != "__root_collection__") {
      path += '<a href="' + link + '">' + items.data.collection.parent.name  + "</a>/";
    }
    link = WEBSERVER + "/category/" + items.data.collection.slug;
    if (items.data.collection.name) {
      path += '<a href="' + link + '">' + items.data.collection.name  + "</a>";
    }

        //console.log("\n+++++++++" + index + " " +JSON.stringify(items.data.collection));
        let article:IArticle = {
          hid :"",
          id :"",
          hname  :"",
          name  :"",
          slug :"",
          hdescription : "",
          description :"",
          img :"",
          price :"",
          soffer :"",
          vcount : 1,
        };

      
        let lastarticle: IArticle;

        for (sitem of items.data.collection.productVariants.items) {
                 
          
          lastarticle = JSON.parse(JSON.stringify(article));

          ++vcount;

          let hid = parseInt(sitem.product.id);
          if (!lastid) {lastid = hid}
          if (hid != lastid) {
            lastarticle.vcount = vcount - 2 ;
            vcount = 1;
            lastprice =  Number.MAX_SAFE_INTEGER;

          }
          article.id = sitem.id;
          article.hname = sitem.product.name;
          article.hid = sitem.product.id;
          article.hdescription = sitem.product.description;
          article.img = imgpath(sitem.product.assets[0].source);
          article.slug = sitem.product.slug;
          for (facet of sitem.product.facetValues) {
              article.soffer ="";
              if (facet.code == "top") {
                article.soffer = 'top';
              }
              if (facet.code == "offer") {
                article.soffer = 'offer' ;
              }
          }
          article.vcount = vcount - 2 ;

          //console.log("facetValues: " + JSON.stringify(article.facetValues));
          //console.log("\n++++" + article.hname + "+++++" + id + " " + lastid + " vcount " + vcount +  "\n"); // +JSON.stringify(sitem));

          let price : number  = sitem.priceWithTax;

          if (price < lastprice) {
            lastprice = price;
          }

          let ab : string = "ab ";
          if (vcount < 2) {
              ab ="  ";
          }
          //console.log("\n++++" + hid + " " + lastid + " vcount " + vcount);
          article.price = ab + numberToCurrency(lastprice);
          //lastarticle.price = article.price;

          if (hid != lastid) {
            //console.log("\n--wechsel id---" + id + " " + lastid + " vcount " + vcount); //\n" +JSON.stringify(lastarticle));
            lastid=hid;
            list.push(lastarticle);
            
          } 
     } 
     ++article.vcount;
     list.push(article);
      // console.log("\n--ende id: " + JSON.stringify(article));
      //     list.push(article); //letzter Artikel

    function detailurl(slug:String) {
      return WEBSERVER + "/items/" + slug;
    }

    return (
          <div>
            <div><MenuComponent props={categories} countx={count}></MenuComponent></div>
            <div className="container-fluid">
            <div className="breadcrums">{<div dangerouslySetInnerHTML={{__html: path}} />}</div>
            <div className="row">
            {list.map((elem) => (
              
              <div key={elem.id} className="product col-md-4">
               <a href={detailurl(elem.slug)}>
               <h4>{elem.hname}</h4> 
               <div className="h-25 boxheight"><small dangerouslySetInnerHTML={{__html:elem.hdescription}}></small></div></a>
               <a href={detailurl(elem.slug)}><div className="img-container">
               <img src={elem.img} className="img-fluid"></img>
               <Soffer type={elem.soffer}></Soffer>
               </div></a> <span>{elem.price} {elem.soffer}</span>
               <div className="d-flex flex-row justify-content-between margin-buy-box">
                  <div><a className="btn btn-info" href={detailurl(elem.slug)}>Details</a></div>
                  {elem.vcount ? <div></div> :
                  <div><PlaceCartComponent idnr={elem.id}  qty="1" func={addCart} select={null}></PlaceCartComponent> </div>
                  }
                </div>
              </div>
              
          ))}
          </div>
          </div>

         </div>);
}


export async function getStaticPaths() {
  const client =  new ApolloClient({
    uri: APISERVER,
    cache: new InMemoryCache(),

  })

    const { data } = await client.query({
      query: gql`
      { collections {
        items {
          id
          name
          slug
          }
        }  
      }
        `,
    })
  
    const paths = data.collections.items.map((item) => ({
      params: { category: item.slug },
    }))

    //console.log("path:" +JSON.stringify(paths))
  
     return { paths, fallback: false };
  }

   export const getStaticProps: GetStaticProps = async (context): Promise<any> => {
    const client =  new ApolloClient({
        uri: APISERVER,
        cache: new InMemoryCache(),
     })
    
    const slugy  = context.params.category;

    const slug = slugy.toString(); //"electronics";
    
    const queries = new Queries();
    const items = await queries.getItemsFromPage(slug);

    //console.log("+++++++++++++++++++slugy" + slugy + JSON.stringify(items));
   
    const categories = await queries.getCategories();
    //console.log("~~~~~~~~~~~~~~~~~" + JSON.stringify(categories))
    
    return {
        props: {
            items,categories,slugy
          },
    };
  
  };
  
